import { Avatar, Box, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { sanitize } from 'dompurify';

import LocationTribe from 'pages/dashboard/tribe/components/TribeCard/components/LocationTribe';
import MemberTribe from 'pages/dashboard/tribe/components/TribeCard/components/MemberTribe';
import React from 'react';
import { appConfig } from 'utils/config';

const TribeImage = styled(Box)(({ theme }) => ({
  width: '152px',
  height: '152px',
  borderRadius: '100%',
  objectFit: 'cover',

  [theme.breakpoints.down('md')]: {
    width: '56px',
    height: '56px',
  },
}));

const RenderHTML = styled(Box)(({ theme }) => ({
  ...theme.typography.paragraph,
  color: theme.palette.neutral300.main,
}));

const TribeInfo = ({ tribe = {} }) => {
  const sanitizedDescription = sanitize(tribe.description);
  const sanitizedPurpose = sanitize(tribe.purpose);

  return (
    <Box>
      <Stack
        p={3}
        sx={{ backgroundColor: 'neutralWhite.main', borderRadius: '8px' }}
      >
        <Stack direction="row" spacing={5}>
          <TribeImage
            component="img"
            src={`${appConfig.baseUrl}${tribe.imageBanner}`}
            alt="tribe-img"
          />
          <Stack spacing={{ xs: 1, md: 2 }}>
            <Box
              bgcolor="primary500.main"
              width="fit-content"
              p={{ xs: '2px 8px', md: '4px 8px' }}
              borderRadius={{ xs: '8px', md: '16px' }}
            >
              <Typography
                typography={{ xs: 'metatag1', md: 'caption1' }}
                color="primaryBrandPurwadhika.main"
                textTransform="uppercase"
              >
                {tribe?.tribeCategory?.name}
              </Typography>
            </Box>

            <Typography typography={{ xs: 'subheading3', md: 'subheading1' }}>
              {tribe.tribeName}
            </Typography>

            <MemberTribe
              tribeMembers={tribe?.tribeMembers?.filter(
                ({ approved }) => approved === true,
              )}
              maxMembers={tribe.maxMembers}
            />

            <LocationTribe tribeLocation={tribe.tribeLocation} />
          </Stack>
        </Stack>

        {/* Tribe Description */}
        <Box mt={3} maxHeight={{ xs: 'unset', md: '600px' }}>
          <RenderHTML
            dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
          />
        </Box>
      </Stack>

      <Stack
        mt={3}
        p={3}
        sx={{ backgroundColor: 'neutralWhite.main', borderRadius: '8px' }}
      >
        <Typography
          typography={{ xs: 'subheading3', md: 'subheading2' }}
          color="primaryBrandPurwadhika.main"
        >
          About Tribe Leader
        </Typography>

        <Box
          mt={{ xs: 1, md: 2 }}
          bgcolor="neutral800.main"
          borderRadius={2}
          p={2}
        >
          <Stack spacing={{ xs: 1, md: 2 }}>
            <Stack direction="row" spacing={{ xs: 1, md: 2 }}>
              <Avatar
                src={`${appConfig.baseUrl}${tribe?.leaderProfilePicture}`}
                sx={{
                  width: { xs: '32px', md: '40px' },
                  height: { xs: '32px', md: '40px' },
                  borderRadius: '100%',
                }}
              />
              <Stack>
                <Typography
                  typography="subheading3medium"
                  color="neutral100.main"
                >
                  {tribe?.leaderFirstName} {tribe?.leaderLastName}
                </Typography>
                <Typography typography="captionreguler" color="neutral400.main">
                  Tribe Leader
                </Typography>
              </Stack>
            </Stack>
            <RenderHTML
              dangerouslySetInnerHTML={{ __html: sanitizedPurpose }}
            />
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
};

export default TribeInfo;
